import React, {Component} from 'react';
import Header from '../components/Header';

export default class Cookies extends Component {
  render() {
    return (
        <div>
          <Header title="Cookies"/>
          <div className="container">
            <p>Fristberegneren anvender cookies til innsamling av statistikk og forbedring av brukervennligheten på hjemmesiden. Ved å klikke deg videre og anvende verktøyet aksepterer du automatisk bruken av disse.</p>
            <p>Cookies anvendes stort sett av alle hjemmesider, og i noen tilfeller er cookies den eneste måten å få en hjemmeside til å fungere etter sin hensikt. En cookie er en fil som oppbevares i din nettleser på din PC, nettbrett eller smarttelefon. Den gjør det mulig å gjenkjenne din PC og samle informasjon om hvilke sider og funksjoner som besøkes med din nettleser. Men cookies kan ikke se hvem du er, hva du heter, hvor du bor eller om PC&#39;en din brukes av en eller flere personer. Den kan heller ikke spre virus eller andre skadelige programmer.</p>
            <p>Du kan alltid endre innstillingene i din nettleser og dermed avvise cookies på din PC. Innstillingene er avhengig av hvilken nettleser du bruker, men alle nettlesere tillater at cookies blir slettet enkeltvis eller samlet. Vær oppmerksom på at det er funksjoner og tjenester på internett som du ikke kan anvende dersom du avviser cookies.</p>
          </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/Cookies.js